module.exports = __webpack_public_path__ + "static/media/dws_controls.0cf4b9df.png";